import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { validarComCalculadoraRTC } from '../api/ApuracaoCBSApi';

export function useValidarCalculadoraRTC() {
  const { toast } = useToast();

  return useMutation({
    mutationFn: validarComCalculadoraRTC,
    onError: () => {
      toast({ variant: 'destructive', title: 'Erro ao validar com a Calculadora RTC.' });
    },
  });
}
